export const formatCurrency = (n) => {
  let amount = 0
  if (typeof n !== "number") { amount = parseFloat(n); }
  if (isNaN(amount)) return n;

  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}